import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Avatar, Progress, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

export const ProgressBar = ({ horisantal, percentage: totalPercentage }) => {
  const performance = useSelector((state) => state.Profile.performance);
  const videos = useSelector((state) => state.Profile.videos);
  const history = useSelector((state) => state.Profile.history);

  const [percentage, setPercentage] = useState(0);

  const calcPercentage = () => {
    const totalSteps = 3;
    let completedSteps = 0;

    if (performance && performance.performances && performance.performances.length > 0) {
      completedSteps++;
    }
    if (videos && Array.isArray(videos) && videos.length > 0) {
      completedSteps++;
    }
    if (history && history.history && history.history.length > 0) {
      completedSteps++;
    }
    const calculatedPercentage = Math.round((completedSteps / totalSteps) * 100);
    setPercentage(calculatedPercentage);
    console.log(totalPercentage, history, videos, performance);
  };

  // Recalcule le pourcentage dès que totalPercentage change ou que l'une des données provenant du store change
  useEffect(() => {
    calcPercentage();
  }, [totalPercentage, performance, videos, history]);

  // Définir les textes en fonction du pourcentage
  const titleText =
    percentage === 100
      ? "Votre profil est complet !"
      : "Vous y êtes presque, finalisez votre profil !";
  const subtitleText =
    percentage === 100
      ? "Bravo, vous avez maximisé vos chances d'attirer les clubs !"
      : "Un profil complet maximise vos chances attirer les clubs.";

  return (
    <>
      {horisantal === "horisantal" ? (
        <div className="d-flex justify-content-center align-items-center gap-4 p">
          <div>
            <h4 className="black-title">{titleText}</h4>
            <p className="fs-5">{subtitleText}</p>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <Progress
              className="mb-2"
              percent={percentage}
              strokeColor="#65A96B"
              strokeWidth={15}
              format={(percent) => `${percent}%`}
            />
          </div>
        </div>
      ) : (
        <div>
          <div className="d-flex justify-content-center align-items-center">
            <Progress
              className="mb-2"
              percent={percentage}
              strokeColor="#65A96B"
              strokeWidth={15}
              format={(percent) => `${percent}%`}
            />
          </div>
          <h4 className="black-title">{titleText}</h4>
          <p className="fs-5">{subtitleText}</p>
        </div>
      )}
    </>
  );
};



export const ProgressBarHorizantal = ({ addPercentage }) => {

  console.log('add', addPercentage)
  return (
    <>
      <div>
        <Progress className='mb-2'
          percent={50 + addPercentage}
          strokeColor="#65A96B" // Custom color (orange-red)
          strokeWidth={15} // Custom height (15px)
        />
        <h4 className="black-title ">Vous y êtes presque, finalisez votre profil !</h4>
        <p className='fs-5'>Un profil complet maximise vos chances d attirer les clubs.</p>
      </div>

    </>
  )
}

